/**
 * Reader testimonials, in display order: paid subscribers first, then the
 * Google reviews.
 *
 * The words are the readers' own: subscriber notes sent at paid sign-up, and
 * public Google reviews of Capitalist Times, the company Roger founded with Elliot Gue.
 * Names and email addresses were removed at the owner's request. The only
 * edits allowed are capitalization, punctuation and the `[...]` trim already
 * shown. Never reword a quote, never merge two, never add a number that is not
 * in the text, and never add a name, initial, handle or email for any of them.
 */
export interface Testimonial {
  /** The quote's number in the source list, kept so edits can be traced. */
  id: number;
  label: string;
  quote: string;
}

const PAID = "Paid subscriber";
const PAID_30 = "Paid subscriber, 30+ years";
const GOOGLE = "Google review, Capitalist Times";

/** The Capitalist Times listing on Google Maps, where the reviews below live. */
export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps?cid=6703197278897831520";

export const TESTIMONIALS: readonly Testimonial[] = [
  {
    id: 1,
    label: PAID,
    quote:
      "Your insights, analysis and approach to investing is based on common sense and is always void of hype. I know I am getting sound analysis that will be of benefit to me and my family. Thanks!",
  },
  {
    id: 2,
    label: PAID_30,
    quote:
      "I've been a member of CUI for over 30 years. Bought ATO in a DRIP when price was $22!!! Have only sold minimal shares. Now I'm retired living off dividends from BCE ATO D DUK SO EPD EXC ETR (in and out of this one) VZ. Love your advice.",
  },
  {
    id: 3,
    label: PAID_30,
    quote:
      "I have been a subscriber for over 30 years. Yours were my first subscriptions ever. Despite regular withdrawals to support our retired life (4 houses on 3 continents) my return without adding back withdrawals has been over 3000%. Thank you and thanks to Elliot also.",
  },
  {
    id: 4,
    label: PAID,
    quote: "Your dividend strategy has been a huge win for me. Thanks.",
  },
  {
    id: 5,
    label: PAID,
    quote:
      "My father has been recommending that I subscribe for several years. He's the most savvy investor I know and winning his admiration is no small achievement.",
  },
  {
    id: 6,
    label: PAID,
    quote:
      "I have listened to you regularly on MoneyLife with Chuck Jaffe. You are one of the favorite guests of many of the listeners for years.",
  },
  {
    id: 7,
    label: PAID,
    quote:
      "I read your Utility Forecaster newsletter and I enjoy it. I have also done pretty good with your energy recommendations.",
  },
  {
    id: 9,
    label: GOOGLE,
    quote:
      "Roger's investment thinking mirrors my own. He does the research and other work, I read, and the benefit has been growing wealth over the years. Nothing fancy, just a steady and comfortable ride up!",
  },
  {
    id: 8,
    label: GOOGLE,
    quote:
      "During times when the market doesn't seem to make much sense, Roger provides clarity and intelligent perspective. There are recommendations for both risk averse as well as aggressive investors. I highly recommend this service for its value and quality.",
  },
  {
    id: 11,
    label: GOOGLE,
    quote:
      "Count on Capitalist Times for steady investing guidance, timely positioning, value-based guidance on buy/sell prices, excellent model portfolios, and a solid sense of what's going on in the market. Look elsewhere if you want breathless, hyperventilating coverage of the market, or a fly-by-night meme-stock wannabe day trader set of services.",
  },
  {
    id: 10,
    label: "Google review, Capitalist Times, reader since 2007",
    quote:
      "I started with Capitalist Times in 2007 when I retired. A friend (former WWII pilot) introduced me to Capitalist Times and Conrad's Utility Investor. I rely on the Capitalist Times Team, CUI and CUI+ to help pay your bills and live my life. I am grateful and appreciative of all that you do!",
  },
  {
    id: 12,
    label: "Google review, Capitalist Times, reader since 2009",
    quote:
      "I have been a subscriber of Roger's and Eliot's publications since 2009 and, over the years, have done very well following their advice. I found they do a particularly excellent job in identifying solid energy and utility companies that are fundamentally solid and poised to make strong moves upwards.",
  },
  {
    id: 13,
    label: GOOGLE,
    quote:
      "If you want expert advice on specialized, international markets like energy and utilities, then Elliot Gue and Roger Conrad are two experts you can trust. [...] They are my 'go-to' experts in these markets and their inputs regularly impact my investment decisions.",
  },
];
